import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  detailUrl: null as any,
};

const detailUrlSlice = createSlice({
  name: 'detailUrl',
  initialState,
  reducers: {
    setDetailUrl: (state, action) => {
      state.detailUrl = action.payload;
    },
    clearDetailUrl: (state) => {
      state.detailUrl = null;
    },
  },
});

export const { setDetailUrl, clearDetailUrl } = detailUrlSlice.actions;
export default detailUrlSlice.reducer;
